"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const customElement_1 = tslib_1.__importDefault(require("../../lib/customElement"));
class TableTitle extends customElement_1.default {
    constructor() {
        super(...arguments);
        this.STYLE = `
        <style>
            h1, h2, h3, p {
                margin: 0;
                padding: 0;
                font-family: sans-serif;
            }

            .table-title {
                margin-left: calc(var(--increment-amount) * 40);
                position: absolute;
                display: block;
            }

            .table-title > div {
                position: relative;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-between;
                width: calc(var(--increment-amount) * var(--element-size) * 7.5);
                height: calc(var(--increment-amount) * var(--element-size) * 3 + var(--border-size) * var(--increment-amount) * 4);
            }

            .table-title h1 {
                font-size: calc(var(--increment-amount) * 12);
                text-align: center;
                margin: auto;
            }
        </style>
    `;
        this.TEMPLATE = `
        <div class="table-title">
            <div>
                <h1>THE PERIODIC TABLE</h1>
                <h1>OF HATE AND</h1>
                <h1>INTOLERANCE</h1>
            </div>
        </div>
    `;
    }
}
exports.default = TableTitle;
//# sourceMappingURL=data:application/json;base64,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